import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { reduxForm, Field, formValueSelector } from "redux-form";
import moment from "moment";

import { TextInput } from "../TextInput";
import { UsersService, TimeFormattingService } from "../../services";
import { SelectInput, SelectAsyncInput } from "../SelectInput";
import { PageLevelAccess } from '../PageLevelAccess';
import i18next from "i18next";

function validate(values) {
  const ERROR_MESSAGES = {
    priority: i18next.t('messages.please-select-priority'),
    status: i18next.t('messages.please-select-status'),
    category: i18next.t('messages.please-select-category'),
    assignedTo: i18next.t('messages.please-select-owner'),
    description: i18next.t('messages.please-enter-description')
  };

  return Object.keys(ERROR_MESSAGES).reduce((errors, property) => {
    if (!values[property]) {
      errors[property] = ERROR_MESSAGES[property];
    }

    return errors;
  }, {});
}

@connect(state => {
  const selector = formValueSelector("TicketForm");
  return {
    description: selector(state, "description"),
    status: selector(state, "status"),
    priority: selector(state, "priority")
  };
})
class TicketForm extends React.Component {
  constructor(props) {
    super(props);

    const {
      initialize,
      categories,
      statuses,
      priorties,
      ticket: { description, category, status, priority, assignedTo }
    } = this.props;

    this.state = {
      showDescriptionEdit: false,
      categoryOptions: categories.map(category => ({
        value: category.id,
        label: category.name,
        category: category
      })),
      statusOptions: statuses.map(status => ({
        value: status.id,
        label: i18next.t(`ticket-statuses.${status.token}`),
        status: status
      })),
      priorityOptions: priorties.map(priority => ({
        value: priority.id,
        label: i18next.t(`ticket-priorities.${priority.token}`),
        priority: priority
      }))
    };

    let formProps = {
      description,
      category: {
        value: category.id,
        label: category.name,
        category
      },
      status: {
        value: status.id,
        label: i18next.t(`ticket-statuses.${status.token}`),
        status
      },
      priority: {
        value: priority.id,
        label: i18next.t(`ticket-priorities.${priority.token}`),
        priority
      }
    };

    if (assignedTo) {
      formProps.assignedTo = {
        value: assignedTo.id,
        label: assignedTo.fullName
      };
    }

    initialize(formProps);
  }

  toggleDescriptionEdit() {
    this.setState({ showDescriptionEdit: !this.state.showDescriptionEdit });
  }

  loadUserOptions(input, callback) {
    if (input.length > 3) {
      UsersService.getAll([{ search: input }], true)
          .then(response => {
            callback(
               response.users.map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`
              }))
            );
          })
          .catch(error => {
            console.error(error);
            callback(error, null);
          });
    } else {
      callback(null, []);
    }
  }

  render() {
    const {
      ticket: {
        device,
        deviceGrouping,
        number,
        createdAt,
        createdBy,
        lastUpdateAt,
        lastUpdatedBy,
        alert
      },
      description,
      priority,
      status,
      pristine,
      handleCancel,
      handleSubmit
    } = this.props;

    return (
        <div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-9">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-8">
                    <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-location">
                      <label>{ i18next.t('pages.tickets.location') }</label>
                      <span>
                      {deviceGrouping.name}{" "}
                        {device ? <span> - {device.displayName}</span> : null}
                    </span>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-4">
                    <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-info-generic">
                      <label>{ i18next.t('pages.tickets.ticket-number') }</label>
                      <span>{number}</span>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <hr className="remove-margin-top" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div
                        className={`card-data-cell remove-border-left card-data-cell-icon ${
                            priority == null
                                ? ""
                                : "priority-icon-" + priority.priority.token
                            }`}
                    >
                      <label>{ i18next.t('form-labels.priority') }</label>
                      <Field
                          async
                          ref="priority"
                          options={this.state.priorityOptions}
                          name="priority"
                          clearable={false}
                          searchable={false}
                          component={SelectInput}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div
                        className={`card-data-cell remove-border-left card-data-cell-icon ${
                            status == null ? "" : "status-icon-" + status.status.token
                            }`}
                    >
                      <label>{ i18next.t('form-labels.status') }</label>
                      <Field
                          async
                          ref="status"
                          options={this.state.statusOptions}
                          name="status"
                          clearable={false}
                          searchable={false}
                          component={SelectInput}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-category">
                      <label>{ i18next.t('form-labels.category') }</label>
                      <Field
                          async
                          ref="category"
                          options={this.state.categoryOptions}
                          name="category"
                          clearable={false}
                          searchable={false}
                          component={SelectInput}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-owner">
                      <label>{ i18next.t('form-labels.owner') }</label>
                      <Field
                          ref="assignedTo"
                          loadOptions={this.loadUserOptions.bind(this)}
                          name="assignedTo"
                          clearable
                          searchable
                          autoload
                          component={SelectAsyncInput}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 form-group ticket-description-wrap">
                    <hr className="remove-margin-top" />
                    <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                      {this.state.showDescriptionEdit ? (
                          <div>
                            <Field
                                type="text"
                                name="description"
                                component={TextInput}
                                label={ i18next.t('form-labels.description') }
                                textarea
                            />
                          </div>
                      ) : (
                          <div>
                            <label>{ i18next.t('form-labels.description') }</label>
                            <p>{description}</p>
                            <PageLevelAccess to='/monitoring/tickets/edit/:ticketId'>
                            <a
                                className="btn btn-default add-margin-top"
                                onClick={this.toggleDescriptionEdit.bind(this)}
                            >
                              { i18next.t('form-labels.edit-description') }
                            </a>
                            </PageLevelAccess>
                          </div>
                      )}
                      {pristine ? null : (
                          <ul className="list-inline clearfix text-right">
                            <li>
                              <button
                                  type="submit"
                                  className="btn btn-primary btn-block"
                              >
                                { i18next.t('form-labels.save') }
                              </button>
                            </li>
                            <li>
                              <Button
                                  onClick={handleCancel}
                                  className="btn btn-default">
                                { i18next.t('form-labels.cancel') }
                              </Button>
                            </li>
                          </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <div
                    className="card-data-side-info">
                  <div className="row">
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left">
                        <label>{ i18next.t('pages.tickets.created') }</label>{" "}
                        <p>{TimeFormattingService.renderFromNowTime(createdAt)}</p>
                      </div>
                    </div>

                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left">
                        <label>{ i18next.t('pages.tickets.creator') }</label>{" "}
                        <p>{createdBy ? createdBy.fullName : "System"}</p>
                      </div>
                    </div>

                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left">
                        <label>{ i18next.t('pages.tickets.updated') }</label>{" "}
                        <p>{TimeFormattingService.renderFromNowTime(lastUpdateAt)}</p>
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="card-data-cell remove-border-left">
                        <label>{ i18next.t('pages.tickets.updater') }</label>{" "}
                        <p>{lastUpdatedBy ? lastUpdatedBy.fullName : "System"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {alert ? (
                      <div className="col-sm-12 form-group">
                        <div className="card-data-cell remove-border-left add-margin-top">
                          <p>
                            <Link
                                className="btn btn-primary btn-block"
                                to={{
                                  pathname: `/monitoring/locations/${deviceGrouping.id}/events/${alert.id}`,
                                  search: "?detail=true",
                                  state: {grouping: this.props.grouping, history: this.props.history, redirectTo: this.props.redirectTo}
                                }}>
                              { i18next.t('form-labels.view-alert') }
                            </Link>
                          </p>
                        </div>
                      </div>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
        </div>
    );
  }
}

export default reduxForm({ form: "TicketForm", validate })(TicketForm);
